<template>
  <!-- SDV Outcomes modal -->
  <div class="modal_wrapper">
    <div class="modal-container">
      <div class="titleclass">
        <h4 class="px-3 mt-1">{{ $t("navigations.assign sdv") }}</h4>
        <div class="closebutton mt-1">
          <a style="color: white" class="close-link">
            <i class="fa fa-times" @click.prevent="closemodal()"></i>
          </a>
        </div>
      </div>

      <div class="modelbody p-0">
        <div class="mb-3 p-2">
          <div class="form-group">
            <!-- Role -->
            <div class="col-lg-8 mb-1">
              <label class="col-form-label">
                {{ $t("navigations.role") }}
                <sup><i class="fa fa-asterisk required"></i></sup>
              </label>

              <select
                v-model="selectedRole"
                class="form-control"
                @change="roleChanged()"
              >
                <option disabled value="">
                  {{ $t("navigations.please select role") }}
                </option>
                <option
                  v-for="role in roleList"
                  :key="role.roleID"
                  :value="role.roleID"
                >
                  {{ role.roleName }}
                </option>
              </select>

              <span class="errorClass" v-if="errors[3]">
                {{ $t("navigations.please select role") }}
              </span>
            </div>

            <!-- Recipients -->
            <div class="col-lg-8 mb-1">
              <label class="col-form-label">
                {{ $t("navigations.user") }}
                <sup><i class="fa fa-asterisk required"></i></sup>
              </label>

              <select
                v-model="values.Recipient"
                class="form-control"
              >
                <option disabled value="">
                  {{ $t("navigations.please select user") }}
                </option>
                <option
                  v-for="recipient in recipients"
                  :key="recipient.email"
                  :value="recipient.email"
                >
                  {{ recipient.email }}
                </option>
              </select>

              <span class="errorClass" v-if="errors[2]">
                {{ $t("navigations.please select user") }}
              </span>
            </div>

            <!-- Save button -->
            <div class="d-flex justify-content-center my-3">
              <button
                @click.prevent="assignSdv()"
                class="save_btn py-1 px-4 position-relative"
              >
                <div
                  class="toc-loader position-absolute"
                  :class="{
                    'opacity-0': !loadingBlock,
                    'opacity-1': loadingBlock
                  }"
                >
                  <img
                    src="../../assets/img/loading.gif"
                    width="15"
                    class="loading-btn-img"
                    alt="Waiting for login"
                  />
                </div>
                <div
                  :class="{
                    'opacity-1': !loadingBlock,
                    'opacity-0': loadingBlock
                  }"
                >
                  {{ $t("navigations.assign") }}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of SDV Outcomes modal -->
</template>
<script src="./AssignSdvModal.js"></script>
<style scoped>
.modal_wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}
.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}
.modelbody {
  overflow: unset !important;
}
.opacity-05 {
  opacity: 0.5;
}

.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}
</style>
